import { render, staticRenderFns } from "./InstantLoginFlow.vue?vue&type=template&id=06e76301&scoped=true&"
import script from "./InstantLoginFlow.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InstantLoginFlow.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./InstantLoginFlow.vue?vue&type=style&index=0&id=06e76301&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e76301",
  null
  
)

export default component.exports